import React, { ReactNode } from 'react';
import { HeaderRow, Table, Wrapper } from './ScheduleHeader.styles';

interface ScheduleHeaderProps {
  children: ReactNode;
}

const ScheduleHeader: React.FC<ScheduleHeaderProps> = ({ children }) => {
  return (
    <Wrapper>
      <Table>
        <thead>
          <HeaderRow>{children}</HeaderRow>
        </thead>
      </Table>
    </Wrapper>
  );
};

export default ScheduleHeader;
